import { FormField } from '@gik/ui-legacy/Form';

export type BillingAddressFieldSetProps = {
  disabled?: boolean;
};

export function BillingAddressFieldSet({ disabled }: BillingAddressFieldSetProps) {
  return (
    <>
      <section className="flex gap-2">
        <FormField name="firstName" className="tw-flex-1" disabled={disabled} />
        <FormField name="lastName" className="tw-flex-1" disabled={disabled} />
      </section>
      <FormField name="companyName" disabled={disabled} />
      {/* <FormField name="country" disabled={disabled} /> */}
      <FormField name="address1" disabled={disabled} />
      <FormField name="address2" disabled={disabled} />
      <section className="flex gap-2">
        <FormField name="city" className="tw-flex-1" disabled={disabled} />
        <FormField name="state" disabled={disabled} />
        <FormField name="postalCode" disabled={disabled} />
      </section>

      <FormField name="phone" className="tw-flex-1" disabled={disabled} />
    </>
  );
}
